<template>
    <div class="campaign-option campaign-adset-location">
        <div class="campaign-option--title">
            Select States
            <info-tooltip text="Select the states where your ad set will appear."></info-tooltip>
        </div>

        <base-state-selector
            data-test="ad-set-state-type"
            v-model="locations"
            :states-list="locationsList"
            placeholder="Select">
        </base-state-selector>

        <label v-show="showErrors && !validation.locations" class="error">The State field is required.</label>
    </div>
</template>

<script>
    import BaseStateSelector from '../shared/base-state-selector.vue'

    export default {
        props: {
            value: {
                type: Array,
                default: 'value'
            },
            locationsList: {
                type: Array
            },
            showErrors: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                locations: this.value
            }
        },
        mounted() {
            this.$emit('input', this.locations);
            this.$emit('validation', 'locations', this.isValid);
        },
        watch: {
            value(val) {
                this.locations = val;
            },
            locations() {
                this.$emit('input', this.locations);
                this.$emit('validation', 'locations', this.isValid);
            }
        },
        computed: {
            validation() {
                return {
                    locations: this.locations != null ? (this.locations.length > 0) : false
                };
            },
            isValid: function () {
                return this.validation.locations;
            }
        },
        components: {
            BaseStateSelector
        }
    }
</script>
